import { QRCodeSVG } from 'qrcode.react';
import React from 'react';

const GenerateQrModal = (menuId, tableId) => {
    let fullHostWithProtocol = window.location.protocol + '//' + window.location.host;
    
    const orderUrl = `${fullHostWithProtocol}/order/${tableId}/${menuId}`

    return <QRCodeSVG
          value={orderUrl}
          size={220}
          bgColor="transparent"
          fgColor={document.body.classList.contains("dark-mode") ? "#fff" : "#000"}
          level="M"
          includeMargin={true}
        />
}


export default GenerateQrModal;